function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "noun_Piggy Bank_821775 (1)");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "noun_Piggy-Bank_821775-(1)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M71.196,47.912 C70.18,42.54 66.309,38.056 61.171,36.243 L65.205,30.272 L64.508,29.675 C64.39,29.573 61.561,27.194 57.601,27.194 C53.869,27.194 50.505,29.235 47.59,33.262 C43.494,31.242 38.884,30.178 34.199,30.178 C19.013,30.178 6.637,41.178 6.149,54.859 C5.28,54.785 3.778,54.518 3.029,53.539 C2.471,52.808 2.412,51.72 2.858,50.302 L0.895,49.688 C0.24,51.778 0.407,53.495 1.395,54.786 C2.69,56.483 5.007,56.85 6.176,56.929 C6.545,63.83 9.939,70.301 15.697,74.883 L16.874,85.804 L26.967,85.804 L30.228,80.948 C34.152,81.454 38.027,81.211 41.824,80.233 L43.782,85.804 L53.931,85.804 L56.997,73.827 C63.768,72.666 68.47,69.036 70.65,63.298 L76.485,63.298 L76.485,47.912 L71.196,47.912 Z M74.429,61.241 L69.185,61.241 L68.95,61.943 C67.101,67.464 62.885,70.796 56.419,71.838 C56.283,71.862 56.122,71.893 55.941,71.933 L55.325,72.07 L52.337,83.748 L45.239,83.748 L43.123,77.73 L42.188,78 C38.176,79.165 34.052,79.446 29.884,78.821 L29.239,78.725 L25.87,83.746 L18.72,83.746 L17.648,73.793 L17.299,73.523 C11.49,69.05 8.159,62.55 8.159,55.69 C8.159,42.755 19.841,32.234 34.199,32.234 C38.861,32.234 43.437,33.361 47.437,35.494 L48.258,35.931 L48.774,35.159 C51.402,31.239 54.372,29.25 57.6,29.25 C59.721,29.25 61.48,30.126 62.423,30.715 L57.861,37.47 L59.289,37.824 C64.588,39.138 68.609,43.657 69.298,49.069 L69.412,49.968 L74.428,49.968 L74.428,61.241 L74.429,61.241 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M28.851,27.609 C33.023,27.609 36.418,24.214 36.418,20.042 C36.418,15.87 33.022,12.476 28.851,12.476 C24.68,12.476 21.288,15.871 21.288,20.042 C21.287,24.215 24.68,27.609 28.851,27.609 Z M28.851,14.531 C31.891,14.531 34.363,17.003 34.363,20.042 C34.363,23.081 31.891,25.554 28.851,25.554 C25.813,25.554 23.343,23.081 23.343,20.042 C23.343,17.003 25.812,14.531 28.851,14.531 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M30.82,54.876 C28.874,54.186 28.081,53.777 28.081,52.522 C28.081,51.213 29.157,50.149 30.478,50.149 C31.799,50.149 32.875,51.213 32.875,52.522 L34.932,52.522 C34.932,50.466 33.512,48.751 31.603,48.253 L31.603,47.021 L29.546,47.021 L29.546,48.193 C27.536,48.621 26.025,50.398 26.025,52.522 C26.025,55.353 28.398,56.197 30.129,56.813 C32.147,57.53 32.968,57.959 32.968,59.329 C32.968,60.639 31.894,61.702 30.572,61.702 C29.25,61.702 28.175,60.639 28.175,59.329 L26.12,59.329 C26.12,61.42 27.588,63.164 29.547,63.63 L29.547,64.787 L31.604,64.787 L31.604,63.628 C33.559,63.162 35.025,61.417 35.025,59.329 C35.024,56.372 32.593,55.506 30.82,54.876 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M24.267,38.606 C27.8,37.086 31.591,36.315 35.533,36.315 L35.533,34.26 C31.31,34.26 27.247,35.087 23.456,36.718 L24.267,38.606 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M60.545,49.771 C60.629,49.96 60.671,50.167 60.671,50.386 C60.671,51.242 59.975,51.94 59.119,51.94 C58.262,51.94 57.564,51.243 57.564,50.386 L55.508,50.386 C55.508,52.377 57.128,53.995 59.118,53.995 C61.107,53.995 62.726,52.377 62.726,50.386 C62.726,49.879 62.623,49.39 62.422,48.936 L60.545,49.771 Z",
  id: "Shape"
}), React.createElement("rect", {
  id: "Rectangle-path",
  x: 23.634,
  y: 3.339,
  width: 2.057,
  height: 7.723
}), React.createElement("rect", {
  id: "Rectangle-path",
  x: 29.921,
  y: 0.803,
  width: 2.056,
  height: 7.722
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "77px",
    height: "86px",
    viewBox: "0 0 77 86",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/piggy-bank.3184b211.svg";
export { SvgComponent as ReactComponent };